import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Card } from 'semantic-ui-react';
import { listConnectionConfigTables } from '../graphql/queries';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

function Connections() {
  // set state
  const navigate = useNavigate();
  const [customerName, setCustomerName] = useState("");
  const [connectionInfo, setConnectionInfo] = useState([]);
  // first data grab
  useEffect(() => {
    async function fetchData() {
      const result = await client.graphql({ query: listConnectionConfigTables });
      if (result) {
        result.data.listConnectionConfigTables.items.sort(dynamicSort("Customer Name"));
        setConnectionInfo(result.data.listConnectionConfigTables.items);
      }
    }

    fetchData();
  }, []);

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  const openConnection = (id) => {
    if (id) {
      navigate('/connection/' + id, { replace: true });
    }
    else {
      navigate('/connection/', { replace: true });
    }
  }
  const filterConnections = () => {
    if(customerName === '' || customerName === undefined) {
      return connectionInfo;
    } 
    return connectionInfo.filter(c => c.CustomerName !== null && c.CustomerName.toLowerCase().includes(customerName.toLowerCase()));
  }

  return (
    <>
    <div className="field">
      <h1 htmlFor="CustomerName">Customer Name Filter</h1>
      <input type="text"  placeholder="Customer Name" id="CustomerName" value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
    </div>
    <br/>
    <Card.Group>
      <Card key="newTop" onClick={() => openConnection()}>
        <Card.Content>
          <Card.Header>Add New</Card.Header>
          <button>Edit</button>
        </Card.Content>
      </Card>
      {filterConnections().map(tData => {
        return (
          <Card key={tData.id} onClick={() => openConnection(tData.id)}>
            <Card.Content>
              <Card.Header>{tData.Name}</Card.Header>
              <div>{tData.CustomerName}</div>
              <div>{tData.ExpirationDate}</div>
              <button>Edit</button>
            </Card.Content>
          </Card>);
      })}
      <Card key="newBottom" onClick={() => openConnection()}>
        <Card.Content>
          <Card.Header>Add New</Card.Header>
          <button>Edit</button>
        </Card.Content>
      </Card>
    </Card.Group>
    </>
  );
}

export default Connections